import { Box } from '@ironhack/design-system2/components/box';
import { Text } from '@ironhack/design-system2/components/text';
import { type StructuredTextGraphQlResponse } from 'react-datocms/structured-text';

import { StructuredContent } from 'app/components/client/structured-content';

type Props = {
  listTitle: string;
  list: StructuredTextGraphQlResponse;
};

export const ReskillingList = (props: Props) => {
  const { list, listTitle } = props;

  return (
    <Box as="section" mt="6">
      <Text mb={3} textStyle="lBold">
        {listTitle}
      </Text>
      <StructuredContent data={list} />
    </Box>
  );
};
